var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a0a0a0;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.534 -2.362) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 11.154,
    transform: "translate(7.577 1.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 11.154,
    transform: "translate(13.154 7.077) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCross);
export default __webpack_public_path__ + "static/media/gray_cross.b28cfe6df821f4c244e5129e53f27ea6.svg";
export { ForwardRef as ReactComponent };